"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Destroyable_1 = require("../destroyable/Destroyable");

var InMemoryJSONEventBuffer_1 = require("../eventbuffer/InMemoryJSONEventBuffer");

var DefaultMeetingEventReporter = /*#__PURE__*/function () {
  function DefaultMeetingEventReporter(eventIngestionConfiguration, logger) {
    _classCallCheck(this, DefaultMeetingEventReporter);

    this.reportingEvents = false;
    this.importantEvents = ['meetingEnded', 'meetingFailed', 'meetingStartFailed', 'audioInputFailed', 'videoInputFailed', 'meetingStartSucceeded'];
    this.destroyed = false;
    var eventsClientConfiguration = eventIngestionConfiguration.eventsClientConfiguration,
        ingestionURL = eventIngestionConfiguration.ingestionURL,
        eventBufferConfiguration = eventIngestionConfiguration.eventBufferConfiguration;
    var eventsToIgnore = eventsClientConfiguration.eventsToIgnore;
    this.eventBuffer = new InMemoryJSONEventBuffer_1.default(eventBufferConfiguration, eventsClientConfiguration, ingestionURL, this.importantEvents, logger);
    this.logger = logger;
    this.eventsToIgnore = eventsToIgnore;
    this.start();
  }

  _createClass(DefaultMeetingEventReporter, [{
    key: "start",
    value: function start() {
      if (this.reportingEvents) {
        return;
      }

      try {
        this.eventBuffer.start();
        this.logger.info('Event reporting started');
        this.reportingEvents = true;
      } catch (error) {
        /* istanbul ignore next */
        this.logger.error("Event Reporting - Error starting the event buffer ".concat(error));
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.reportingEvents) {
        return;
      }

      try {
        this.eventBuffer.stop();
        this.logger.info('Event reporting stopped');
        this.reportingEvents = false;
      } catch (error) {
        /* istanbul ignore next */
        this.logger.error("Event Reporting - Error stopping the event buffer ".concat(error));
      }
    }
  }, {
    key: "reportEvent",
    value: function reportEvent(ts, name, attributes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.logger.debug("Event Reporting - DefaultMeetingEventReporter - event received in reportEvent ".concat(ts, ", ").concat(name, ", ").concat(JSON.stringify(attributes)));

                if (!this.eventsToIgnore.includes(name)) {
                  _context.next = 4;
                  break;
                }

                this.logger.debug("Event Reporting - DefaultMeetingEventReporter - ".concat(name, " event will be ignored as it is in events to ignore"));
                return _context.abrupt("return");

              case 4:
                _context.prev = 4;
                this.logger.debug("Event Reporting - DefaultMeetingEventReporter - adding item to event buffer");
                _context.next = 8;
                return this.eventBuffer.addItem({
                  ts: ts,
                  name: name,
                  attributes: attributes
                });

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](4);
                this.logger.error("Event Reporting - Error adding event to buffer ".concat(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.destroyed = true;
                this.stop();
                /* istanbul ignore else */

                if (Destroyable_1.isDestroyable(this.eventBuffer)) {
                  this.eventBuffer.destroy();
                }

                this.eventBuffer = undefined;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return DefaultMeetingEventReporter;
}();

exports.default = DefaultMeetingEventReporter;